import HOSPITAL_ACTIVITY_AREA_MAP from '../../../../shared/ramq/domainValues/activityAreas';
import dateHospitalisation from '../DateHospitalisation/dateHospitalisation';
import intensiveCareExceptionalCircumstances from '../ExceptionalCircumstances/intensiveCareExceptionalCircumstances';
import { ActCode } from './ActCode';
import { RequiredDetails } from '../requiredDetail.type';
import referenceProfessional from '../ReferenceProfessional/referenceProfessional';

export default class ActCode9160 implements ActCode {
  // eslint-disable-next-line no-unused-vars
  constructor(private act: any) {}

  getRequiredDetails(): RequiredDetails {
    const requiredDetails = [dateHospitalisation, referenceProfessional];

    if (this.act.activityArea === HOSPITAL_ACTIVITY_AREA_MAP.intensiveCareUnit) {
      requiredDetails.push(intensiveCareExceptionalCircumstances);
    }

    return requiredDetails;
  }
}
